import { ProcessTypeConfigModel } from "../../models/processTypeConfigModel";

export function updateShortDescriptionRequiredField(config: ProcessTypeConfigModel) {

    if (config.IsShortDescriptionRequired) {
        show();

        if (config.IsSimpleProcess) {
            $("#short-description-label-text").text("Bejelentés tárgya, rövid leírása ").append("<sup class=\"required\">*</sup>");
        }
        else {
            $("#short-description-label-text").text("Kérelem rövid leírása ").append("<sup class=\"required\">*</sup>");
        }
    }
    else {
        hide();
    }

    function hide() {
        $("#short-description-section").hide();
        $("#short-description-label-text .required").hide();
    }

    function show() {
        $("#short-description-section").show();
        $("#short-description-label-text .required").show();
    }
}
